/** Believable kitchen temperatures. Matches the save check on the server. */

export const FOOD_SAFETY_TEMPERATURE_MIN = -60
export const FOOD_SAFETY_TEMPERATURE_MAX = 300

export const FOOD_SAFETY_TEMPERATURE_BOUNDS_MESSAGE =
  'Temperatures must be between -60°C and 300°C — check the reading'

export const FOOD_SAFETY_IMPOSSIBLE_READING_NOTE =
  'A new reading like this would be refused.'

/** Null when the field is empty or inside the range. */
export function foodSafetyTemperatureBoundError(value) {
  if (value == null || value === '') return null
  const n = Number(value)
  if (!Number.isFinite(n)) return null
  if (n < FOOD_SAFETY_TEMPERATURE_MIN || n > FOOD_SAFETY_TEMPERATURE_MAX) {
    return FOOD_SAFETY_TEMPERATURE_BOUNDS_MESSAGE
  }
  return null
}

export function probeDraftHasImpossibleTemperature(draft) {
  return (
    foodSafetyTemperatureBoundError(draft?.value) != null ||
    foodSafetyTemperatureBoundError(draft?.boilingValue) != null
  )
}
